var React = require('react');

function Shape2 (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#E4D3C8","d":"M0.047,76.02c0,0,36.643-22.849,60.127-13.978\n\t\tc23.485,8.873,45.729,15.388,64.086,5.966c18.358-9.422,15.678-18.533,22.644-35.148c6.97-16.615,6.433-41.27,42.344-30.015\n\t\tc35.91,11.256,23.045,26.577,40.734,45.716c17.686,19.138,31.085,24.076,54.133,15.71c23.047-8.365,59.754,54.016,6.832,71.6\n\t\tc-52.926,17.584-78.116,15.443-110.276-2.781c-32.158-18.225-38.591-35.857-84.684-19.002\n\t\tc-46.093,16.855-80.932,12.724-88.971-0.217C-1.024,100.929,0.047,76.02,0.047,76.02"})));
}

Shape2.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","width":"318.121px","height":"147.972px","viewBox":"0 0 318.121 147.972","enableBackground":"new 0 0 318.121 147.972","xmlSpace":"preserve"};

module.exports = Shape2;

Shape2.default = Shape2;
